import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const uploadCustomerUsersBatchFile = async ({
  customerId,
  file,
  sendInvite,
}: {
  customerId: string;
  file: File;
  sendInvite: boolean;
}) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("send_invite", String(sendInvite));
    const url = `/v3/customers/${customerId}/users/bulk`;
    const response = await axiosClient.post(url, formData);
    const resData = response?.data;
    if (resData?.statusCode === 200 && resData?.success) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getCustomerUsersBatchFailures = async (jobId: string) => {
  try {
    const url = `/v3/bulk-onboarding/users/${jobId}/failures`;
    const response = await axiosClient.get(url);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getCustomerUsersBatchList = async ({
  limit = 100,
  offset = 0,
}: {
  limit?: number;
  offset?: number;
}) => {
  try {
    const url = "/v3/bulk-onboarding/users";
    const response = await axiosClient.get(url, {
      params: { limit, offset },
    });
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const cancelCustomerUsersBatchJob = async (jobId: string) => {
  try {
    const url = `/v3/bulk-onboarding/users/${jobId}/cancel`;
    const response = await axiosClient.post(url);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
